import React from 'react';
import { cn } from '@express-labs/raven-tools';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slider,
} from 'pure-react-carousel';
import IconLeft from '../IconLeft';
import IconRight from '../IconRight';
import s from '../../Carousel.scss';
import s2 from './CategoryOutfits.scss';
import RenderSlideOutfits from '../RenderSlideOutfits';

export type CategoryOutfitsProps = {
  ariaLabelItems?: string[];
  cards?: never;
  className?: string;
  classNameButtonLeft?: string;
  classNameButtonRight?: string;
  classNameButtons?: string;
  classNameSlider?: string;
  currentSlide?: number;
  largeImages?: string[];
  mainImages?: string[];
  selectedItem?: number;
  visibleSlides?: number;
};

export type CategoryOutfitsPropsInjectedByCarousel = {
  onClick: (i: number, ev: React.MouseEvent<HTMLElement>) => void;
  onKeyDown: (i: number, ev: React.KeyboardEvent<HTMLElement>) => void;
  uid: number;
};

const CategoryOutfits = ({
  ariaLabelItems = [],
  className,
  classNameButtonLeft,
  classNameButtonRight,
  classNameButtons,
  classNameSlider,
  currentSlide = 0,
  largeImages = [],
  mainImages = [],
  onClick,
  onKeyDown,
  selectedItem,
  uid,
  visibleSlides = 3,
}: CategoryOutfitsProps & CategoryOutfitsPropsInjectedByCarousel) => {
  const totalOfProducts = Math.max(mainImages.length, largeImages.length);
  return (
    <CarouselProvider
      className={cn(s.categoryOutfitsContainer, s2.wrapper, className)}
      currentSlide={currentSlide}
      data-testid="CategoryOutfits"
      data-uid={uid}
      hasMasterSpinner={false}
      lockOnWindowScroll
      naturalSlideHeight={700}
      naturalSlideWidth={660}
      totalSlides={mainImages.length}
      visibleSlides={visibleSlides}
    >
      <Slider
        className={cn(s.categoryOutfitsSlider, s2.slider, classNameSlider)}
      >
        {mainImages.map((mainImage, i) => (
          <RenderSlideOutfits
            ariaLabel={ariaLabelItems[i]}
            i={i}
            key={largeImages[i]}
            large={largeImages[i]}
            main={mainImages[i]}
            onClick={onClick}
            onKeyDown={onKeyDown}
            selectedItem={selectedItem}
            totalOfProducts={totalOfProducts}
            uid={uid}
          />
        ))}
      </Slider>
      <div className={cn(s.buttonsSlider, classNameButtons)}>
        <ButtonBack
          className={cn(s.buttonBackDisabledHidden, classNameButtonLeft)}
        >
          <IconLeft />
        </ButtonBack>
        <ButtonNext
          className={cn(s.buttonNextDisabledHidden, classNameButtonRight)}
        >
          <IconRight />
        </ButtonNext>
      </div>
    </CarouselProvider>
  );
};

export default CategoryOutfits;
